import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TableComponentEnum from './../../utils/TableComponentEnum';
import TableRowColumn from './TableRowColumn';
import maskLoaderImg from './../../../assets/images/loader.gif';

class TableBody extends Component {
  static componentType = TableComponentEnum.TABLEBODY;
  constructor() {
      super();
      this.emptyTableDataMessage = 'No data can be found'
  };

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
  };


  onClick = (event) => {
  //  if (this.props.onClick) {
  //    this.props.onClick(event, this.props.columnNumber);
  //  }
  };

    createTableRowColumns = () => {
        var self = this;
        var rowColumnComponentList = [];
        // we iterate the results from the fetch service and the list containing table fields and keys
        // using this we generate tr element that contains table rows columns
        // this is use for test only for adhoc reports
        if (this.props.tableDataResults !== undefined) {
            if (this.props.showMask) {
                rowColumnComponentList.push(<tr key="1"><td colSpan={this.props.tableHeaderColumnList.length}><img src={maskLoaderImg} className="centerSpinnerImage"/></td></tr>);
            } else {
                if (this.props.tableDataResults.length > 0) {
                    this.props.tableDataResults.map(function(item, index) {
                        var rowColumnComponent = {};
                        rowColumnComponent = <tr key={index}>
                            {self.props.tableHeaderColumnList.map(columnItem => {
                                return (
                                    <TableRowColumn key={columnItem.key}>
                                        {item[columnItem.key]}
                                    </TableRowColumn>
                                );
                            })}
                        </tr>
                        rowColumnComponentList.push(rowColumnComponent);
                    })
                } else {
                    rowColumnComponentList.push(<tr key="11"><td colSpan={this.props.tableHeaderColumnList.length}>{this.emptyTableDataMessage}</td></tr>);
                }


            }
        } else {
            if (this.props.showMask) {
                rowColumnComponentList.push(<tr key="1"><td colSpan={this.props.tableHeaderColumnList.length}><img src={maskLoaderImg} className="centerSpinnerImage"/></td></tr>);
            } else {
                rowColumnComponentList.push(<tr key="11"><td colSpan={this.props.tableHeaderColumnList.length}>{this.emptyTableDataMessage}</td></tr>);
            }
        }
        return rowColumnComponentList;
    };

  render() {
    const {
      children,
      className,
      onClick, // eslint-disable-line no-unused-vars
    } = this.props;

    const handlers = {
      onClick: this.onClick,
    };

    return (
      <tbody
        className={className}
        {...handlers}
      >
      {(this.props.type !== undefined) ?
          this.createTableRowColumns()
          : ''}
      {children}
      </tbody>
    );
  }
}

export default TableBody;
